import axios from "axios";
export default axios.create({
  baseURL:
    process.env.NODE_ENV === "production"
      ? "https://api.lauramadeira.com"
      : "http://localhost:5000",
});
